import React, { Component } from "react";
import Chrome from "@zendesk/knowledge-chrome/lib/Chrome";
import t from "@zendesk/client-i18n-tools";
import { Button } from "@zendeskgarden/react-buttons";
import { getCurrentBrandId } from "@zendesk/knowledge-context";
import Gap from "@zendesk/knowledge-components/lib/Gap";
import Wizard from "@zendesk/knowledge-components/lib/Wizard";
import { Mutation, Query } from "react-apollo";
import gql from "graphql-tag";
import LoadingOverlay from "components/LoadingOverlay";

import { completeStepMutation } from "mutations/completeStepMutation";
import { gotoPreviousStepMutation } from "mutations/gotoPreviousStepMutation";

import { showIndex } from "utils/navigation";

import hasPreviousStep from "state/hasPreviousStep";
import isStepBefore from "state/isStepBefore";
import steps from "state/steps";

import FrequencyStep from "components/FrequencyStep";
import SegmentStep from "components/SegmentStep";
import NotificationStep from "components/NotificationStep";
import ReviewStep from "components/ReviewStep";
import ArticleMatches from "components/ArticleMatches";
import CreateVerificationRuleMutation from "components/CreateVerificationRuleMutation";

import styles from "./styles.css";

const currentStepQuery = gql`
  query CurrentStep {
    wizard @client {
      currentStep
    }
  }
`;

export default class NewRoute extends Component {
  showIndex = e => {
    e.preventDefault();
    showIndex();
  };

  render() {
    return (
      <Chrome
        brandId={getCurrentBrandId()}
        dir={t.dir}
        topNav={
          <Chrome.Breadcrumbs>
            <Chrome.Breadcrumbs.Item key="settings">
              <a href="/hc/admin/general_settings">
                {t("knowledge-verification.settings")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item key="verification">
              <a href="/knowledge/verification/" onClick={this.showIndex}>
                {t("knowledge-verification.articleVerifications")}
              </a>
            </Chrome.Breadcrumbs.Item>
            <Chrome.Breadcrumbs.Separator />
            <Chrome.Breadcrumbs.Item key="newRule">
              {t("knowledge-verification.newRule")}
            </Chrome.Breadcrumbs.Item>
          </Chrome.Breadcrumbs>
        }
      >
        <Query query={currentStepQuery}>
          {({ data: { wizard } }) => (
            <LoadingOverlay>
              <div className={styles.content}>
                <div className={styles.step}>
                  <div className={styles.form}>
                    <h1 className={styles.title}>
                      {t("knowledge-verification.createVerificationRule")}
                    </h1>
                    <div className={styles.wizardContainer}>
                      <Wizard dir={t.dir}>
                        {steps.map(step => (
                          <Wizard.Step
                            key={step}
                            label={t(`knowledge-verification.step.${step}`)}
                            active={wizard.currentStep === step}
                            completed={isStepBefore(step, wizard.currentStep)}
                          />
                        ))}
                      </Wizard>
                      <div className={styles.wizardStep}>
                        {wizard.currentStep === "frequency" && (
                          <FrequencyStep />
                        )}
                        {wizard.currentStep === "segment" && <SegmentStep />}
                        {wizard.currentStep === "notification" && (
                          <NotificationStep />
                        )}
                        {wizard.currentStep === "review" && <ReviewStep />}
                      </div>
                    </div>
                  </div>
                  {["segment", "review"].includes(wizard.currentStep) && (
                    <ArticleMatches />
                  )}
                </div>
                <div className={styles.buttons}>
                  {hasPreviousStep(wizard.currentStep) ? (
                    <Mutation mutation={gotoPreviousStepMutation}>
                      {mutate => (
                        <Button size="small" onClick={mutate}>
                          {t("knowledge-verification.back")}
                        </Button>
                      )}
                    </Mutation>
                  ) : (
                    <Button size="small" onClick={this.showIndex}>
                      {t("knowledge-verification.cancel")}
                    </Button>
                  )}
                  <Gap />

                  {wizard.currentStep === "review" ? (
                    <CreateVerificationRuleMutation>
                      {mutate => (
                        <Button size="small" primary onClick={mutate}>
                          {t("knowledge-verification.create")}
                        </Button>
                      )}
                    </CreateVerificationRuleMutation>
                  ) : (
                    <Mutation mutation={completeStepMutation}>
                      {mutate => (
                        <Button size="small" primary onClick={mutate}>
                          {t("knowledge-verification.next")}
                        </Button>
                      )}
                    </Mutation>
                  )}
                </div>
              </div>
            </LoadingOverlay>
          )}
        </Query>
      </Chrome>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NewRoute/index.js